import React, { useEffect, useState } from 'react';
import { number, func, string } from 'prop-types';

import ModalInterior from '@alltrails/shared/components/ModalInterior';
import ModalBackground from '@alltrails/shared/components/ModalBackground';

import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../utils/server_communication_util';
import { loadAndExecuteRecaptcha } from '../../utils/recaptcha_helpers';
import downloadOptions from './download_util';

import SelectDropdown from '../forms/SelectDropdown';

import * as styles from './styles/styles.module.scss';

const DownloadRouteModal = ({ mapId, trailSlug, toggleDownloadModal, className }) => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [selectedDownloadOption, setDownloadOption] = useState(downloadOptions[0]);

  const handleSelectChange = e => {
    const value = e.currentTarget.dataset.value;
    const selected = downloadOptions.find(option => option.value === value);
    setDownloadOption(selected);
  };

  useEffect(() => {
    loadAndExecuteRecaptcha('downloadRoute', token => {
      setRecaptchaToken(token);
    });
  });

  const handleDownload = () => {
    if (!recaptchaToken) {
      return;
    }
    const format = selectedDownloadOption?.value;
    _gaq.push(['_trackEvent', 'MapDownload', format, mapId ? 'Map' : 'Trail']);
    if (mapId) {
      window.location = `/maps/${mapId}/gpx?key=${ServerCommunicationUtil.apiKey}&format=${format}&recaptcha=${recaptchaToken}`;
      toggleDownloadModal(false);
    } else {
      window.location = `/${trailSlug}/gpx?ref=trail-more-gpx&format=${format}&recaptcha=${recaptchaToken}`;
      toggleDownloadModal(false);
    }
  };

  const displayTitle = StringConstantsMixin.strings.TRACK_DETAIL.DOWNLOAD_ROUTE;

  return (
    <ModalBackground closeModal={toggleDownloadModal} className={className} goBack={null}>
      <ModalInterior
        title={displayTitle}
        closeModal={toggleDownloadModal}
        isMounted
        baseCtas={{
          primaryCta: {
            onClick: handleDownload,
            children: StringConstantsMixin.strings.EDIT_RECORDING.OK
          },
          secondaryCta: {
            onClick: toggleDownloadModal,
            children: StringConstantsMixin.strings.CANCEL
          }
        }}
        goBack={null}
      >
        <div className={styles.downloadModalContainer}>
          <span className={styles.modalSubText}>{StringConstantsMixin.strings.TRACK_DETAIL.CHOOSE_FILE_FORMAT}</span>
          <div className={styles.dropdownContainer}>
            <SelectDropdown
              options={downloadOptions}
              handleChange={handleSelectChange}
              defaultItem={selectedDownloadOption}
              className={styles.fullWidth}
              materialRootClass={styles.medium}
            />
          </div>
        </div>
      </ModalInterior>
    </ModalBackground>
  );
};

DownloadRouteModal.propTypes = {
  mapId: number,
  trailSlug: string,
  toggleDownloadModal: func,
  className: string
};

DownloadRouteModal.defaultProps = {
  mapId: 0,
  trailSlug: '',
  toggleDownloadModal: () => {},
  className: ''
};

export default DownloadRouteModal;
